// Uday brand marks for auth/onboarding/share surfaces. The sparkle package's
// DustLogo/DustLogoSquare draw Dust's logo inline; this deployment is
// white-labeled, so visible marks render the Uday SVG instead (same asset the
// email layout, notifications and PDF footer use).
export function UdayLogoSquare({ className }: { className?: string }) {
  return (
    <img
      src="/static/landing/logos/uday/Uday_LogoSquare.svg"
      alt="Uday"
      draggable={false}
      className={`object-contain ${className ?? ""}`}
    />
  );
}

export function UdayLogo({ className }: { className?: string }) {
  return (
    <img
      src="/static/landing/logos/uday/Uday_LogoSquare.svg"
      alt="Uday"
      draggable={false}
      className={`object-contain ${className ?? ""}`}
    />
  );
}
